<mat-card class="feed-card">
    <div class="feed-card-header">
        <span class="feed-card-icon"><mat-icon>poll</mat-icon></span>
        <div class="feed-card-heading">
            <div class="feed-card-title-row">
                <h3 class="feed-card-title">{{ poll.title }}</h3>
                <span class="bg-label other mat-small" *ngIf="poll.isExpired">Votação encerrada</span>
                <span class="bg-label success mat-small" *ngIf="poll.hasVoted">Você votou</span>
            </div>
            <span class="feed-card-meta">
                <mat-icon>schedule</mat-icon>
                <span>{{ poll.isExpired ? 'Encerrada em' : 'Aberta até' }} {{ poll.dueDate | date:"dd/MM/yyyy 'às' HH:mm" }}</span>
                <ng-container *ngIf="poll.createdBy != null"><span>·</span><span>{{ poll.createdBy }}</span></ng-container>
            </span>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="pollMenu" aria-label="Opções da enquete"
            *ngIf="allowPostManagement && (poll.allowDeletion || allowEditingAnyPost)">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #pollMenu="matMenu">
            <button mat-menu-item (click)="viewVotes()">
                <mat-icon>how_to_vote</mat-icon>
                <span>Ver Votos</span>
            </button>
            <button mat-menu-item (click)="deletePoll()">
                <mat-icon>delete</mat-icon>
                <span>Excluir</span>
            </button>
        </mat-menu>
    </div>

    <mat-radio-group class="poll-options" [ngClass]="{'readonly': !poll.allowVoting}">
        <div *ngFor="let option of poll.options" class="poll-option" [class.selected]="option.isSelected"
            [class.with-results]="showResults">
            <mat-radio-button [value]="option.id" color="primary" [checked]="option.isSelected" (click)="voteInPoll(option)">
                <span class="poll-option-text">{{ option.description }}</span>
            </mat-radio-button>
            <ng-container *ngIf="showResults">
                <span class="poll-option-percentage">{{ option.percentage | percent }}</span>
                <div class="poll-option-bar"><span [style.width.%]="option.percentage * 100"></span></div>
                <span class="poll-option-votes">{{ option.votes }} {{ option.votes == 1 ? 'voto' : 'votos' }}</span>
            </ng-container>
        </div>
    </mat-radio-group>

    <div class="feed-card-footer" *ngIf="showResults">
        <span class="feed-card-stat">
            <mat-icon>how_to_vote</mat-icon>
            {{ totalVotes }} {{ totalVotes == 1 ? 'voto' : 'votos' }} no total
        </span>
    </div>
</mat-card>
